import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { isLoggedIn } from "./../../util";
import {
  UploadUserCsv,
  dismissLogs,
  initiateUpload,
  UploadDealerCsv,
  daimlerUploadVehicleCsv,
} from "../../actions/control_panel_action";
import { Dimmer, Loader, Grid } from "semantic-ui-react";
import CommonForAllPannels from "./CommonForAllPannels.jsx";
import { Button, Modal } from "semantic-ui-react";

class DaimlerKeyControlPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      diamlerkeyuserCsvFile: null,
      diamlerkeydealersCsvFile: null,
      diamlerkeyvehicleCsvFile: null,
    };
  }

  componentWillMount() {
    if (!isLoggedIn(this.props.auth)) {
      this.props.history.push(`/login`);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!isLoggedIn(nextProps.auth)) {
      this.props.history.push(`/login`);
      return false;
    }
    return true;
  }

  diamlerkeyhandleUserFileUpload = (files) => {
    const file = files.target.files[0];
    this.setState({ diamlerkeyuserCsvFile: file });
    files.target.files = null;
  };

  diamlerkeyhandleDealerFileUpload = (files) => {
    const file = files.target.files[0];
    this.setState({ diamlerkeydealersCsvFile: file });
    files.target.files = null;
  };

  diamlerkeyhandleVehicleFileUpload = (files) => {
    const file = files.target.files[0];
    this.setState({ diamlerkeyvehicleCsvFile: file });
    files.target.files = null;
  };

  diamlerkeyuploadUserData = () => {
    let keyUrl = "/admin/v1/keymanagement/addUsers";
    this.props.initiateUpload(true);
    this.props.uploadUserCsv(keyUrl, this.state.diamlerkeyuserCsvFile);
  };

  diamlerkeyuploadDealerData = () => {
    let keyDealerUrl = "/admin/v1/keymanagement/addDealers";
    this.props.initiateUpload(true);
    this.props.uploadDealerCsv(
      keyDealerUrl,
      this.state.diamlerkeydealersCsvFile
    );
  };

  diamlerkeyuploadVehicleData = () => {
    let keyDaimlerVandiUrl = "/admin/v1/keymanagement/addVehicles";
    this.props.initiateUpload(true);
    this.props.uploadVehicleCsv(
      keyDaimlerVandiUrl,
      this.state.diamlerkeyvehicleCsvFile
    );
  };

  diamlerkeycloseLog = () => {
    this.props.dismissLogs(false);
  };

  render() {
    let keyPannel = [
      {
        itemForSpan: "Upload User CSV to add Users",
        itemInputChange: this.diamlerkeyhandleUserFileUpload,
        itemClickButton: this.diamlerkeyuploadUserData,
        itemContentForButton: "Upload User CSV",
      },
      {
        itemForSpan: "Upload Dealer CSV to add Dealers",
        itemInputChange: this.diamlerkeyhandleDealerFileUpload,
        itemClickButton: this.diamlerkeyuploadDealerData,
        itemContentForButton: "Upload Dealer CSV",
      },
      {
        itemForSpan: "Upload Vehicle CSV to add Vehicles",
        itemInputChange: this.diamlerkeyhandleVehicleFileUpload,
        itemClickButton: this.diamlerkeyuploadVehicleData,
        itemContentForButton: "Upload Vehicle CSV",
      },
    ];
    return (
      <div
        style={{
          marginLeft: "2vw",
          marginTop: "7vh",
          fontWeight: "bold",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <Dimmer active={this.props.controlPanel.uploadIncomplete}>
          <Loader size="massive">Uploading</Loader>
        </Dimmer>
        <Grid columns={2}>
          <Grid.Row>
            <CommonForAllPannels child={keyPannel} color={this.props.color} />
          </Grid.Row>
        </Grid>
        {this.props.controlPanel.showLog && (
          <Modal
            close={this.diamlerkeycloseLog}
            open={this.props.controlPanel.showLog}
          >
            <Modal.Header>Upload Report</Modal.Header>
            <Modal.Content>
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.controlPanel.log,
                }}
              />
            </Modal.Content>
            <Modal.Actions>
              <Button color="black" onClick={this.diamlerkeycloseLog}>
                Dismiss
              </Button>
            </Modal.Actions>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    home: state.home,
    controlPanel: state.controlPanel,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      uploadUserCsv: UploadUserCsv,
      uploadDealerCsv: UploadDealerCsv,
      uploadVehicleCsv: daimlerUploadVehicleCsv,
      initiateUpload: initiateUpload,
      dismissLogs: dismissLogs,
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DaimlerKeyControlPanel)
);
